import * as Actions from '../actions/contentBlockActions';

export type ContentBlockState = {
        expandedContainer: string | null;
        expandedBlock: string | null;
};

export type ContentBlockAction = {
    type: typeof Actions.EXPAND_BLOCK | typeof Actions.COLLAPSE_BLOCK;
    payload: {
        containerName: string | null;
        blockName: string | null;
    };
}

const initialState: ContentBlockState = {
    expandedContainer: null,
    expandedBlock: null
};

function contentBlock(state = initialState, action: ContentBlockAction): ContentBlockState {
    const st = {...state};

    switch (action.type) {
        case Actions.EXPAND_BLOCK: {
            st.expandedContainer = action.payload.containerName;
            st.expandedBlock = action.payload.blockName;

            return st;
        }

        case Actions.COLLAPSE_BLOCK: {
            st.expandedContainer = null;
            st.expandedBlock = null;

            return st;
        }

        default: {
            return state;
        }
    }
}

export default contentBlock;
